import { combineReducers } from 'redux';

import * as constants from 'app/modules/participants/constants';

const { PARTICIPANT_CREATE } = constants;

/*
 * Reducers
 */

export const byId = (state = {}, action) => {
  switch (action.type) {
    case PARTICIPANT_CREATE:
      let participantId = action.record.id;
      return {
        ...state,
        [participantId]: singleParticipantReducer(state[participantId], action),
      };
    default:
      return state;
  }
};

export const allIds = (state = [], action) => {
  switch (action.type) {
    case PARTICIPANT_CREATE:
      let participantId = action.record.id; // TBD
      if (state.indexOf(participantId) < 0) {
        return state.concat(participantId);
      }
      return state;
    default:
      return state;
  }
};

export default combineReducers({
  byId,
  allIds,
});

function singleParticipantReducer(state = {}, action) {
  switch (action.type) {
    case PARTICIPANT_CREATE:
      return action.record;
    default:
      return state;
  }
}

/*
 * Action creators
 */

export const createParticipant = record => ({ type: PARTICIPANT_CREATE, record });
